import type {ControlOption} from 'shells/card/segmented-control';
import {ENTITY_TYPE_SELECT_OPTIONS} from 'shells/create-custom-field/consts';
import {ChevronDown} from 'shells/icon/svg/chevron-down-icon';
import {RadioIcon} from 'shells/icon/svg/radio-icon';
import type {SelectWithIconOption} from 'shells/select-picker/select-with-icon/select-with-icon';

import type {CustomFieldView} from '../blocks-and-design/content-blocks/types';

import type {Source} from './types';

export const VIEW_LABELS: Record<CustomFieldView, string> = {
    'short-text': 'Short text',
    'long-text': 'Long text',
    dropdown: 'Dropdown',
    radio: 'Radio',
    checkbox: 'Checkbox',
    date: 'Date',
};

export const VIEWS_WITH_CHOICES = new Set<CustomFieldView>(['dropdown', 'radio', 'checkbox']);

export const VIEWS_WITHOUT_PLACEHOLDER = new Set<CustomFieldView>(['radio', 'checkbox', 'date']);

export type SingleChoiceFieldPresentation = 'radio' | 'dropdown';

export const SINGLE_CHOICE_FIELD_TYPE_SELECT_OPTIONS: SelectWithIconOption[] = [
    {value: 'radio', label: 'Radio', icon: RadioIcon},
    {value: 'dropdown', label: 'Dropdown', icon: ChevronDown},
];

export const SOURCE_OPTIONS: ControlOption<Source>[] = [
    {value: 'new', title: 'New field', type: 'small'},
    {value: 'existing', title: 'Existing field', type: 'small'},
];

export const ENTITY_OPTIONS: SelectWithIconOption[] = ENTITY_TYPE_SELECT_OPTIONS.map((opt) => ({
    value: opt.value,
    label: opt.label,
    icon: opt.icon as React.ComponentType<any>,
}));
